var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 105,
    viewBox: "0 0 118 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1_2245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M82.1119 71.1125C85.7441 75.3325 88.085 82.5809 89.9148 87.8603C89.1875 79.8944 90.2913 70.4358 90.6102 62.3501L33.1357 33.9624L82.1119 71.1125Z",
    fill: "#E1DEE5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.75629 18.6318C33.0114 35.1164 58.2427 51.4661 83.0059 70.6247C76.3202 81.1872 63.8573 84.266 57.1961 95.4857C43.4706 81.618 41.5203 73.2762 30.9836 56.7689C24.9795 47.3634 9.99029 26.1828 1.75629 18.6318Z",
    stroke: "#A0CE7C",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M50.6583 43.057C62.3426 49.4863 76.5301 59.5075 89.496 62.3808C93.812 55.8585 102.08 49.6048 108.612 44.9679C75.7086 36.7533 35.6219 21.8957 1.75629 18.6318C1.75629 18.6318 35.5559 34.7392 50.6583 43.057Z",
    stroke: "#A0CE7C",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M82.1119 71.1123C85.7441 75.3324 88.085 82.5808 89.9148 87.8602C89.1875 79.8942 90.2913 70.4356 90.6102 62.35",
    stroke: "#A0CE7C",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102.96,
    height: 88.94,
    fill: "white",
    transform: "translate(0 17.4419) rotate(-10.8846)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.89d8a6b9f80a969ecf0e8cc798113351.svg";
export { ForwardRef as ReactComponent };